import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { EmployeeContractEffects } from './employee-contract.effects'
import * as fromEmployeeContract from './employee-contract.reducer';
import { EmployeeContractService } from './employee-contract.service'
import { EmployeeContractSerializer } from './employee-contract.serializer'
import { EmployeeContractShowComponent } from './show/show.component'

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(fromEmployeeContract.FEATURE_NAME, fromEmployeeContract.employeeContractReducer),
        EffectsModule.forFeature([EmployeeContractEffects])
    ],
    declarations: [EmployeeContractShowComponent
    ],
    exports: [EmployeeContractShowComponent
    ],
    providers: [EmployeeContractService, {
            provide: EmployeeContractSerializer,
            useClass: EmployeeContractSerializer
        }]
})
export class EmployeeContractModule {}
